"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CommonModels_1 = require("./CommonModels");
var ProductType;
(function (ProductType) {
    ProductType["PRODUCT"] = "product";
    ProductType["GIFTCARD"] = "giftCard";
    ProductType["FEE"] = "fee";
    ProductType["TIP"] = "tip";
    ProductType["PAYMENT_FEE"] = "paymentFee";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var EProductStrainType;
(function (EProductStrainType) {
    EProductStrainType["SATIVA"] = "Sativa";
    EProductStrainType["SATIVA_DOMINANT"] = "Sativa Dominant";
    EProductStrainType["INDICA"] = "Indica";
    EProductStrainType["INDICA_DOMINANT"] = "Indica Dominant";
    EProductStrainType["HYBRID"] = "Hybrid";
    EProductStrainType["CBD"] = "CBD";
    EProductStrainType["BALANCED"] = "Balanced";
    EProductStrainType["BLEND"] = "Blend";
})(EProductStrainType || (EProductStrainType = {}));
function filterProduct(product, searchQuery) {
    var e_1, _a;
    if (searchQuery === void 0) { searchQuery = ''; }
    /**
     * Search for:
     * id
     * name
     * sku
     * barcode
     */
    searchQuery = searchQuery.toLowerCase();
    var parentId = product.id;
    var parentName = (product.parentProductName || '').toLowerCase();
    var name = (product.name || '').toLowerCase();
    var parentSku = (product.sku || '').toLowerCase();
    var parentBarcode = product.barcode || '';
    if (parentId === searchQuery || name.includes(searchQuery) || parentName.includes(searchQuery) || parentSku.includes(searchQuery) || parentBarcode.includes(searchQuery)) {
        return true;
    }
    try {
        for (var _b = __values(product.childProducts), _c = _b.next(); !_c.done; _c = _b.next()) {
            var childProduct = _c.value;
            var childId = childProduct.id;
            var childName = (childProduct.name || '').toLowerCase();
            var childSku = (childProduct.sku || '').toLowerCase();
            var childBarcode = childProduct.barcode || '';
            if (childId === searchQuery || childName.includes(searchQuery) || parentName.includes(searchQuery) || childSku.includes(searchQuery) || childBarcode.includes(searchQuery)) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
}
exports.filterProduct = filterProduct;
var ProductSearchFilter = /** @class */ (function (_super) {
    __extends(ProductSearchFilter, _super);
    function ProductSearchFilter(json) {
        var _this = _super.call(this, json) || this;
        _this.selectedSupplierId = undefined;
        _this.searchQuery = json.searchQuery;
        _this.selectedSupplierId = json.selectedSupplierId;
        _this.selectedCategoryIds = json.selectedCategoryIds;
        _this.sku = json.sku;
        _this.barcode = json.barcode;
        _this.isActive = json.isActive;
        _this.isDeleted = json.isDeleted;
        _this.selectedStrainTypes = json.selectedStrainTypes;
        _this.selectedTagIds = json.selectedTagIds;
        return _this;
    }
    return ProductSearchFilter;
}(CommonModels_1.Pagination));
exports.ProductSearchFilter = ProductSearchFilter;
//# sourceMappingURL=Product.js.map